export default __webpack_public_path__ + "static/media/Investigation.90b89c2a.png";